export default {
  "screen0": {
    "title": "การเทรดที่โปร่งใส ขับเคลื่อนด้วยระบบที่โปร่งใส",
    "subTitle": "การเทรดอาจมีจุดที่ยาก บางครั้งต้องมีแรงกระตุ้น ระดับของการเข้าถึงตลาดที่ไม่มีใครเทียบได้<br/>โครงสร้างไอทีที่มีความหน่วงต่ำเป็นพิเศษ"
  },
  "screen1": {
    "line1": "ระยะเวลาส่งคำสั่งซื้อต่ำกว่า",
    "line2": "ความเสถียรสูงถึง",
    "line3": "เครือข่ายใยแก้วนำแสงเฉพาะ",
    "line4": "ก้าวให้ทันโลก"
  },
  "screen2": {
    "title": "เทคโนโลยีช่วยให้การเทรดกับ",
    "desc": "เซิร์ฟเวอร์เฉพาะของ EBC ถูกตั้งค่าใน Equinix LD4, HK3, TY3, NY4 เพื่อสร้างความคุ้มครองทั่วโลกสำหรับระบบนิเวศทางการเงิน",
    "title1": "เทคโนโลยีช่วยให้การเทรดกับ EBC ของแต่ละธุรกรรมภายใน 20 มิลลิวินาที ",
    "desc1": "โครงสร้างพื้นฐานแบบ Hyper-Converged ทำให้ระบบมีความเสถียรสูงถึง 98.75% อ้างอิงจากการประมวลผลของซอฟต์แวร์ ความจุในการจัดเก็บข้อมูลและเคลือข่าย",
    "desc2": "<p> ในตลาดการเงินในปัจจุบัน ความเร็วหมายถึงผลกำไร และความคล่องตัวเป็นสิ่งสำคัญสำหรับธุรกรรมที่ทำกำไร </p><p> เราสร้างเซิร์ฟเวอร์ธุรกรรมในศูนย์ข้อมูลชั้นนำของโลก Equinix LD4, HK3, TY3, NY4 การเชื่อมต่อความเร็วสูงพิเศษทั่วโลกของเราช่วยลดความล่าช้าระหว่างภูมิภาค เพื่อให้ลูกค้าของเราได้เพลิดเพลินกับสภาพแวดล้อมการซื้อขายที่มีเสถียรภาพมากขึ้น</ p> <p> การจำกัดไฟร์วอลล์และเครือข่ายระหว่างประเทศที่หนาแน่นส่งผลให้ประสบการณ์การซื้อขายที่มีคุณภาพต่ำ เราติดตั้ง DC เกือบ 30 แห่ง (รวมถึงเซิร์ฟเวอร์การกู้คืนจากความเสียหาย) และเซิร์ฟเวอร์ทั้งหมดในยุโรปและเอเชียเชื่อมต่อผ่านสายการเงินเฉพาะที่มีเครือข่ายเพียร์ทูเพียร์</p> <p> เมื่อเทียบกับเซิร์ฟเวอร์แบบดั้งเดิมในยุโรปและเอเชีย ความล่าช้าใน EBC จากลอนดอนไปยังเอเชียนั้นควบคุมได้ภายใน 100 มิลลิวินาที ในขณะที่เวลาในการรับส่งข้อมูลจากลอนดอนไปยังเอเชียที่เสนอโดยโบรกเกอร์แบบดั้งเดิมนั้นมากกว่า 270 มิลลิวินาที ซึ่งเป็นประโยชน์อย่างยิ่งต่อลูกค้าในเอเชียอย่างไม่ต้องสงสัย</p>"
  },
  "screen3": {
    "title": "เราตระหนักดีว่ากุญแจสู่ความสำเร็จคือสถานการณ์ที่เกิดขึ้นทั้งหมด ไม่จำกัดเฉพาะในส่วนของเทคโนโลยีซอฟต์แวร์",
    "desc": "เรารับประกันสภาพคล่องที่ดีที่สุดในตลาดซื้อขาย เพื่อที่คุณจะได้มีความยืดหยุ่นมากขึ้น ในขณะที่ได้รับสภาพคล่องจากหลายสินทรัพย์มากขึ้น",
    "plant": "",
    "btn": "ศูนย์เรียนรู้"
  },
  "screen4": {
    "enTitle": "ผลักดันให้คุณประสบความสำเร็จ",
    "title": "เทคโนโลยีทางการเงินระดับมืออาชีพและชั้นนำทำให้การซื้อขายเป็นไปได้อย่างไร้ขีดจำกัด"
  },
  "screen5": {
    "plant": "",
    "btn": "ศูนย์เรียนรู้",
    "title": "ลดความเสี่ยงและเพิ่มโอกาสในการซื้อขายสูงสุด ",
    "desc": "ค่าดีเลย์ที่ต่ำมากของ EBC ทำให้การส่งคำสั่งซื้อเป็นไปได้ที่รวดเร็ว มีประสิทธิภาพและน่าเชื่อถือ",
    "list": [
      "เซิร์ฟเวอร์การซื้อขาย",
      "ใบเสนอราคารวม",
      "การส่งคำสั่งซื้อขายไปยังตลาด",
      "สภาพคล่องที่มี"
    ],
    "link1": "ดูชั่วโมงการซื้อขาย",
    "link2": "ดูค่าสเปรดและผลิตภัณฑ์ทั้งหมด"
  },
  "screen6": {
    "title": "มุ่งเน้นไปด้านการเทรดโดยที่ไม่ต้องกังวลเรื่องโครงสร้าง IT ระบบปฎิบัติการ เครือข่ายและฮาร์ดแวร์ เราจึงมุ่งมั่นที่จะให้สภาพคล่องที่เหมาะสมและการดำเนินการส่งคำสั่งซื้อที่ดีเยี่ยม",
    "desc": "ตามคำสั่งที่มีระดับความซับซ้อน 5 ระดับแรก EBC ต้องการเพียง 75-125 มิลลิวินาทีในการทำธุรกรรมให้ลุล่วง"
  },
  "screen7": {
    "pageTitle": "ค้นหาราคาที่เหมาะสม และ การโอนคำสั่งซื่อขาย",
    "pageEnTitle": "ค้นหาราคาที่เหมาะสม และ การโอนคำสั่งซื่อขาย",
    "title": "EBC ใช้ FIX (Financial Information Exchange Protocol) เพื่อรวมราคาสกุลเงินระหว่างธนาคาร เพื่อให้ลูกค้าสามารถเข้าถึงตลาดโดยตรงด้วยสภาพคล่องที่เหมาะสม ราคาที่รวบรวมผ่านฮาร์ดแวร์ HUB ที่มีอยู่จริงทำให้สเปรดที่ต่ำกว่าและโอกาสในการซื้อขายที่ยั่งยืน",
    "desc": "",
    "imgUrl": "th"
  },
  "screen8": {
    "title": "ด้วยระบบของ EBC ช่วยให้ราคาที่แสดงผลบนหน้าจอมีความละเอียด และทำให้ค่าสเปรดอยู่ในระดับที่ยอมรับได้ ",
    "desc": "ภาพรวมโดยสังเขป",
    "link1": "สินทรัพย์ 4 ระดับ",
    "link2": "เครื่องมือการซื้อขายมากกว่า 100 แบบ",
    "link3": "All products",
    "trList": [
      "hierarchy",
      "buying price",
      "trading volume bought ",
      "point difference",
      "selling price ",
      "selling price volume "
    ],
    "smallTrList": [
      "hierarchy",
      "buying price",
      "point difference",
      "selling price "
    ]
  },
  "screen9": {
    "title": "กล่องดำธุรกรรม",
    "smallTitle": "ริธึมคำสั่งขายที่ถูกต้องเหมาะสมที่สุด ทำให้ได้ราคาที่ดีในคำสั่งซื้อมากกว่า 85%",
    "desc": "ที่บันทึกข้อมูลการเทรดของ EBC อิงจากข้อมูลการซื้อขายในอดีตนับสิบล้าน นิสัยการซื้อขายของเทรดเดอร์ คุณลักษณะของผู้ใช้และลักษณะอื่นๆ สถานการณ์ตลาดปัจจุบันและสภาพแวดล้อมของเครือข่ายการค้าใช้การวิเคราะห์ทางสถิติจำนวนมาก โมเดลความน่าจะเป็น โมเดลเครือข่าย Neural โมเดลทฤษฎีการควบคุมระบบ และอัลกอริธึมปัญญาประดิษฐ์เพื่อทำการวิจัยและตัดสินอย่างครอบคลุม และสุดท้ายก็จับคู่ LP ที่เหมาะสมกว่าสำหรับผู้ค้าแต่ละรายเพื่อให้บรรลุราคาซื้อขายที่ดีที่สุด",
    "link1": "ดูชั่วโมงการซื้อขาย",
    "link2": "ดูสเปรดและผลิตภัณฑ์ทั้งหมด",
    "imgUrl": "th"
  },
  "screen10": {
    "desc": "แผนภาพการกระจายต่อไปนี้แสดงผลการเปรียบเทียบระหว่างการเทรดผ่านที่บันทึกข้อมูลของ EBC และระบบการซื้อขายแบบเดิม (มีคำสั่งซื้ออย่างน้อย 100 รายการ):: ",
    "list": [
      "จุดข้อมูลแต่ละจุดแสดงถึงการทำธุรกรรมของวัน",
      "แกนแนวนอนหมายถึงอัตราการทำธุรกรรมของการสั่งซื้อ",
      "ขนาดของจุดแสดงถึงขนาดสัมพัทธ์ของปริมาณการสั่งซื้อ",
      "แกนแนวตั้งบ่งชี้อัตราการเพิ่มประสิทธิภาพของราคาธุรกรรม"
    ],
    "btn": "เริ่มต้นการเทรด",
    "title": "ประสบการณ์นี้ยืนยันว่าที่บันทึกข้อมูลของ ECB นั้นเหนือกว่าระบบการซื้อขายแบบดั้งเดิม ในแง่ของอัตราการเพิ่มประสิทธิภาพราคาการสั่งซื้ออัตราการทำธุรกรรมและความมั่นคงอัลกอริทึม"
  }
}


